const setCustomData = (customData: {} | null) => ({
  type: 'SET_CUSTOM_DATA',
  customData,
})

export default setCustomData
